import { render, staticRenderFns } from "./TodoSettingSidebar.vue?vue&type=template&id=005d1221&scoped=true&"
import script from "./TodoSettingSidebar.vue?vue&type=script&lang=js&"
export * from "./TodoSettingSidebar.vue?vue&type=script&lang=js&"
import style0 from "./TodoSettingSidebar.vue?vue&type=style&index=0&id=005d1221&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "005d1221",
  null
  
)

export default component.exports